export const selectPreloaderVideos = (state) => state.preloader.videos;
